import { createSlice } from '@reduxjs/toolkit';
import { USERS_INITIAL_STATE } from './users.constants';
import {
  createUserReducer,
  fetchUsersReducer,
  removeUserReducer,
  updateUserPrivilegesReducer,
  updateUserReducer,
  grantProjectPrivilegesReducer,
  revokeProjectPrivilegesReducer,
} from './users.reducers';

// Create the users slice
const usersSlice = createSlice({
  name: 'users',
  initialState: USERS_INITIAL_STATE,
  reducers: {
    // Add any specific synchronous reducers here if needed
  },
  extraReducers: builder => {
    fetchUsersReducer(builder);
    createUserReducer(builder);
    removeUserReducer(builder);
    updateUserPrivilegesReducer(builder);
    updateUserReducer(builder);
    grantProjectPrivilegesReducer(builder);
    revokeProjectPrivilegesReducer(builder);
  },
});

// Export the reducer
export default usersSlice.reducer;
